export default function () {
  return {
    mensajes: null,
    mensajesTipo: null,
  };
}
